import { CreateSubWallet } from '../../pages';
import React, { useState } from 'react';
import * as yup from 'yup';
import { WalletController } from '../../controllers';
import constant from '../../utils/constant';
import { MimaToastUtil } from '../../components';
import { useGetAllActiveReviews } from '../../controllers/SurveyController';
import { userStore } from '../../stores';

const CreateSubwalletContainer = ({ closeModal, setShowSurvey }) => {
	const [loading, setLoading] = useState(false);

	const { needFeedback } = useGetAllActiveReviews(constant.FEEDBACK.PETTYCASHCREATE);

	const validationSchema = () => {
		return yup.object({
			name: yup.string().required('Name is required'),
			limit: yup.number().required('Limit is required').min(1, 'Limit is required'),
			limitPeriod: yup.string().required('Period is required'),
		});
	};

	const onSubmit = async (payload) => {
		setLoading(true);
		const { status, errorMessage } = await WalletController.createSubWallet(payload);
		if (status === constant.Success) {
			setLoading(false);
			MimaToastUtil.success({
				message: constant.Success,
			})
			closeModal();
			if (needFeedback._id) {
				setShowSurvey(true)
				userStore.setReviewId(needFeedback._id)
			}
			return;
		}
		setLoading(false);
		return MimaToastUtil.error({
			message: errorMessage,
		});
	}

	return (
		<CreateSubWallet
			closeModal={closeModal}
			onSubmit={onSubmit}
			validationSchema={validationSchema}
			loading={loading}
		/>
	);
};

export default CreateSubwalletContainer;
